import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "triangle-left",
  "use": "triangle-left-usage",
  "viewBox": "0 0 32 30",
  "content": "<symbol viewBox=\"0 0 32 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"triangle-left\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9971 17.2917C10.9796 16.4909 10.9796 14.9491 11.9971 14.1483L17.2845 9.98733C18.5965 8.9548 20.5213 9.88942 20.5213 11.559V19.881C20.5213 21.5506 18.5965 22.4852 17.2845 21.4527L11.9971 17.2917Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol